import { Button, Paper, TextField } from '@mui/material';
import * as React from 'react';
import MyDialog from '../custom-components/dialog';
import MyTable from '../custom-components/table'
import Autocomplete from "@material-ui/lab/Autocomplete";

import { db } from '../firebase';

export default function ManageAdmin() {
    let [adminPool, setadminPool] = React.useState([])
    let [playerPool, setplayerPool] = React.useState([])

    const columns = ['Name', 'Email', 'Uid', 'Remove']
    const [openDialog, setopenDialog] = React.useState(false)
    const [selectedAdmin, setselectedAdmin] = React.useState(null)
    const [selectedAdminName, setselectedAdminName] = React.useState(null)
    const [playerSearchBar, setplayerSearchBar] = React.useState(null)

    function handleRemove(player) {
        console.log(player)
        setselectedAdmin(player)
        setselectedAdminName(player.Name)
        setopenDialog(true)
    }

    function confirmDeleteAdmin() {
        console.log('Confirm delete', selectedAdmin)
        db.collection('appusers').doc(selectedAdmin.Uid)
            .update({
                private: {
                    isAdmin: false,
                    isDev: false
                }
            })
            .then(() => {
                getPlayerPool()
                setopenDialog(false)
            })
            .catch((e) => {
                console.log(e)
                setopenDialog(false)
            })
    }

    function addAdmin() {
        console.log(playerSearchBar.Uid)
        db.collection('appusers').doc(playerSearchBar.Uid)
            .update({
                private: {
                    isAdmin: true
                }
            })
            .then(() => {
                console.log(playerSearchBar.Name, 'added to admin')
                getPlayerPool()
            })
            .catch((e) => {
                console.log(e)
            })
    }

    function getPlayerPool() {
        db.collection("appusers").get()
            .then((querySnapShot) => {
                var newAdminPool = []
                var newPlayerPool = []
                querySnapShot.forEach((doc) => {
                    const data = doc.data()
                    const player = {
                        Name: data.displayName,
                        Email: data.email,
                        Uid: data.uid,
                        Remove: (<Button variant='outlined' color='error' onClick={() => { handleRemove(player) }} >Remove</Button>)
                    }

                    if (data.private.isAdmin || data.private.isDev)
                        newAdminPool.push(player)
                    newPlayerPool.push(player)
                })
                setadminPool(newAdminPool)
                setplayerPool(newPlayerPool)
            })
            .catch((e) => {
                console.log(e)
            })
    }

    React.useEffect(() => {
        getPlayerPool()
    }, [])

    return (
        <div className='center margin'>
            <Paper className='center margin padding flex'>
                <h5>Add admin here: </h5>
                <Autocomplete
                    id="search-bar"
                    onChange={(event, newval) => {
                        setplayerSearchBar(newval)
                    }}
                    options={playerPool}
                    getOptionLabel={(option) => option.Name + ' ' + option.Email}
                    style={{ width: 400 }}
                    renderInput={(params) => <TextField {...params} label="Users" />}
                />

                <Button variant='outlined' color='success' onClick={addAdmin} >Add</Button>
            </Paper>

            <MyTable columns={columns} rows={adminPool}></MyTable>
            <MyDialog dialogTitle={'Delete Admin'} dialogContent={'Do you want to remove ' + selectedAdminName + ' from admin?'} open={openDialog} closeDialog={() => { setopenDialog(false) }} onConfirm={confirmDeleteAdmin} ></MyDialog>
        </div>

    );
}

